import { render } from "./DetailContainer.vue?vue&type=template&id=59eb6862"
import script from "./DetailContainer.vue?vue&type=script&lang=ts"
export * from "./DetailContainer.vue?vue&type=script&lang=ts"
script.render = render

export default script